import { IDatasetAction, datasetState } from "../../models/dataset";
import {
  createDatasetRequest,
  createDatasetSuccess,
  datasetFailure,
  fetchDatasetRequest,
  fetchDatasetSuccess,
  uploadAttachmentRequest,
  uploadAttachmentSuccess,
} from "../actions/dataset";

export const getInitialState = () => ({
  isFetchingDataset: false,
  isUploadAttachemnt: false,
  dataset: null,
});
const datasetReducer = (
  state: datasetState = getInitialState(),
  action: IDatasetAction
) => {
  switch (action.type) {
    case fetchDatasetRequest:
    case createDatasetRequest:
      return { ...state, isFetchingDataset: true };
    case uploadAttachmentRequest:
      return { ...state, isUploadAttachemnt: true };
    case fetchDatasetSuccess:
      return {
        ...state,
        isFetchingDataset: false,
        dataset: action.data,
      };
    case createDatasetSuccess:
      return {
        ...state,
        isFetchingDataset: false,
        dataset: action.data,
      };
    case uploadAttachmentSuccess:
      return {
        ...state,
        isUploadAttachemnt: false,
        dataset: action.data,
      };
    case datasetFailure:
      return { ...state, isFetchingDataset: false };
    default:
      return state;
  }
};

export default datasetReducer;
